import { APIRequest } from '@reverbdotcom/discovery-ui';
import Renderer from '../react_renderer';

window.Reverb = window.Reverb || {};
Reverb.AjaxLoadAndReplace = (function () {
  // Loads content via ajax into a container.
  // Example:
  //    <div id='mycontainer'>this will be replaced by the contents returned from the link</div>
  //    <a href="/path/to/get/content" data-ajax-load-into="#mycontainer">Click Me To Load into #mycontainer</a>
  function ajaxLoadInto() {
    $(document).on('click', 'a[data-ajax-load-into]', function (e) {
      e.preventDefault();

      const clickedLink = $(this);
      const $container = $(clickedLink.data('ajax-load-into'));

      $container.load(clickedLink.prop('href'));
    });
  }

  // Loads content via ajax, slides the old containter up,
  // while sliding down the new content. When slide up is
  // finished, the old container is removed.
  function ajaxSlideReplace() {
    const linkSelector = 'a[data-ajax-slide-replace]';
    $(document).on('click', linkSelector, function (e) {
      e.preventDefault();

      const $clickedLink = $(this);
      const disableWithText = $clickedLink.data('ajax-slide-disable-with');
      const $container = $($clickedLink.data('ajax-slide-replace'));

      const url = $clickedLink.prop('href');
      const req = APIRequest.get(url);

      if (disableWithText) {
        $($clickedLink).addClass('btn-disabled').html(disableWithText);
      }

      req.done((content) => {
        $(content).insertAfter($container).slideDown('slow');
        $container.slideUp('slow', () => {
          $container.remove();
        });
      });
    });
  }

  function ajaxAppendTo() {
    $(document).on('click', 'a[data-ajax-append-to]', function (e) {
      e.preventDefault();

      const link = $(this);
      const container = $(link.data('ajax-append-to'));

      const url = link.prop('href');
      const req = APIRequest.get(url);

      req.done((content) => {
        container.append(content);
        link.trigger('reverb.ajax.append-to.complete');
      });
    });
  }

  // After submitting an ajax button, we may want to refresh its container
  // We look for the container that has the "ajax-refresh-from" data attribute, and
  // pull that attribute to get the new source
  function ajaxRefreshFrom() {
    $(document).on('ajax:success', '[data-ajax-refresh-from]', function (e) {
      const container = $(this);
      container.load(container.data('ajax-refresh-from'));
    });
  }

  // Specifies that the results of a remote form should populate a dom element
  // Example:
  //  .results
  //    # content will go here after the form executes
  //
  //  = form_tag foo_url, data: {"ajax-load-into" => ".results"}
  //    = submit_tag
  //

  function bindAjaxLoadIntoForms() {
    $(document).on('submit', 'form[data-ajax-load-into]', function (e) {
      e.preventDefault();
      const $target = $(e.target);
      const $form = $(this);
      const containerSelector = $target.data('ajax-load-into');

      ajaxLoadIntoForms($form, $target, containerSelector);
    });
  }

  // This function takes a selector for container because we want to trigger an event
  // on the container AFTER it has been replaced, which means we need to find it again
  function ajaxLoadIntoForms(form, spinnerTarget, containerSelector, callBack) {
    return remoteSubmitWithSpinner(form, spinnerTarget).done((xhr) => {
      $(containerSelector).replaceWith(xhr.responseText);
      $(containerSelector).trigger('reverb.ajax_load.complete');

      if (callBack) {
        callBack();
      }
    });
  }

  // Specifies that the results of a remote form should replace an element
  // Example:
  //  .results
  //    # content will go here after the form executes
  //
  //  = form_tag foo_url, data: {"ajax-replace" => ".results"}
  //    = submit_tag
  //
  function ajaxReplaceForms() {
    $(document).on('submit', 'form[data-ajax-replace]', function (e) {
      e.preventDefault();
      const $target = $(e.target);
      const $form = $(this);

      remoteSubmitWithSpinner($form, $target).done((xhr) => {
        const containerSelector = $target.data('ajax-replace');
        $(containerSelector).replaceWith(xhr.responseText);
        initTips(containerSelector);
        Renderer.render(global, document.querySelector(containerSelector));
      });
    });
  }

  function remoteSubmitWithSpinner(form, $target) {
    return remoteSubmit(form).progress(() => {
      $target.spin();
    }).done(() => {
      $target.stopSpinner();
    });
  }

  function remoteSubmit(form) {
    const promise = new $.Deferred();
    form.on('ajax:beforeSend', (e) => {
      promise.notify();
    });
    form.on('ajax:success', (e, xhr) => {
      promise.resolve(xhr);
    });
    form.on('ajax:error', (e, xhr) => {
      promise.resolve(xhr);
    });
    $.rails.handleRemote(form);
    return promise;
  }

  function init() {
    ajaxSlideReplace();
    ajaxLoadInto();
    ajaxRefreshFrom();
    bindAjaxLoadIntoForms();
    ajaxReplaceForms();
    ajaxAppendTo();
  }

  return {
    init,
    ajaxLoadIntoForms,
  };
}());

Reverb.AjaxLoadAndReplace.init();
